export default {
    '1c-diagram1': {
        'diagram-task': 'Identify the problem with the original. Pick one or more answers',
        'rule1': 'Rule 1 Idea above is not a summary of the ideas grouped below',
        'rule2': 'Rule 2 Ideas in each grouping not of the same kind',
        'rule3': 'Rule 3 Ideas in each group not in logical order',
        'complete-title': 'submit',
        'resubmit-title': 'resubmit',
        'hint-title': 'hint',
    }
}



// WEBPACK FOOTER //
// ./client/app/components/diagrams/1/1c/diagram1/i18n/en.js